import {
  CalendarByYearQuery,
  WellbeingAwarenessDaysCalendarPage,
  WellbeingAwarenessDaysCalendarPageQuery,
} from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import {
  QUERY_CALENDAR_BY_YEAR,
  QUERY_WELLBEING_AWARENESS_DAYS_CALENDAR_PAGE,
} from '@/graphql/queries/wellbeing-awareness-days-calendar/wellbeing-awareness-days-calendar';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<WellbeingAwarenessDaysCalendarPageQuery>({
      query: QUERY_WELLBEING_AWARENESS_DAYS_CALENDAR_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.wellbeingAwarenessDaysCalendarPage?.data?.attributes as WellbeingAwarenessDaysCalendarPage,
    error,
  };
};

export const getWellbeingCalendar = async () => {
  const apolloClient = initializeApollo();

  const currentYear = new Date().getFullYear();

  const { data, error } = await requestHandler(
    apolloClient.query<CalendarByYearQuery>({
      query: QUERY_CALENDAR_BY_YEAR,
      variables: {
        year: currentYear,
      },
      fetchPolicy: 'network-only',
    }),
  );

  const calendar = data?.calendars?.data[0];

  return { data: calendar, error };
};
